import React, { useEffect, useState, useRef, useLayoutEffect } from 'react';
import Header from '../layout/Header';
import Sidebar from '../layout/Sidebar';
import Footer from '../layout/Footer';
import Breadcrumbs from '../Reusables/Breadcrumbs';
import '../../scss/create_new.scss';
import { useDispatch, useSelector } from 'react-redux';
import { parseBreadcrumbsList } from '../../store/Actions';
import getResponse from '../actions/Brands.js';
import getResponseEntity from '../actions/Entity.js';
import { useNavigate, useLocation } from "react-router-dom";
import Wheel from '@uiw/react-color-wheel';
import fontList from '../data/FontList.json';
import EntityTasks from './EntityTasks';
import EntitySettings from './EntitySettings';
import Cookies from 'js-cookie';
import RefreshToken from '../actions/RefreshToken';
import downArrow from '../../images/common/bluedownarrow.png';
import upArrow from '../../images/common/blueuparrow.png';
import pickerCursor from '../../images/common/color-picker-svg.svg';
import placeholder from '../../images/common/logo-placeholder.png';
import edit from '../../images/common/edit-blue.png';
import upload_placeholder from '../../images/common/upload-placeholder.png';
import Snackbars from '../Reusables/Snackbar';
import upsort from '../../images/common/upsort.png';
import downsort from '../../images/common/downsort.png';
import trash from '../../images/common/trash.png';
import download from '../../images/projectdetails/download.png';
import Config from '../actions/Config';
import DeleteItem from '../popups/DeleteItem';
import Spinner from '../Reusables/Spinner';
import LoadingOverlay from 'react-loading-overlay';
import { CopyToClipboard } from "react-copy-to-clipboard";
import Tooltip from "@material-ui/core/Tooltip";
import { trim, getStateList, getCountryNameArray } from '../Reusables/Function';
import CityStatedropdown from '../../components/Reusables/CityStatedropdown';
import create from '../../images/projectdetails/add.png';
import Upload from '../popups/Upload';
import Dropdown from '../../components/Reusables/Dropdown';
import getCommonResponse from '../actions/Common';
import EntityNotes from './EntityNotes';
import EntityContacts from './EntityContacts';
import EntityAdditional from './EntityAdditional';
import SubBrands from './SubBrands';
import { convertUTCToPST, convertToDateString } from '../Reusables/Function';
import FormsTable from '../Reusables/FormsTable.jsx';


function ClickOutsidePhone(ref, setcountryCodeDropdownClick) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
            setcountryCodeDropdownClick(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
}

function ClickOutsideCountry(ref, setcountryDropdownClick) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
            setcountryDropdownClick(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
}

function ClickOutsideBrand(ref, setbrandDropdownClick) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
            setbrandDropdownClick(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
}

function ClickOutsidefont1(ref, setfont1DropdownClick) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
            setfont1DropdownClick(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);

}

function ClickOutsidefont2(ref, setfont2DropdownClick) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
            setfont2DropdownClick(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
}

function CreateNew() {
    const BASE_URL = Config();
    const [enable, setEnable] = useState(true);
    const countryCodes = require('country-codes-list');
    const path = window.location.pathname;
    const pathSplit = path.split('/');
    const id = parseInt(pathSplit[pathSplit.length - 2]);
    const pageType = pathSplit[pathSplit.length - 1];
    var parsedValues = null;
    const [pageData, setPageData] = useState(null);
    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [page, setPage] = useState("");
    const uploadedImage = React.useRef(null);
    const imageUploader = React.useRef(null);
    const countryCallingCodeObject = countryCodes.customList('countryCode', '+{countryCallingCode}');
    const [callingCodes, setCallingCodes] = useState([]);
    const [callingCodeSuggestions, setCallingCodeSuggestions] = useState([]);
    const [countryNames, setCountryNames] = useState([]);
    const [editCliked, setEditClicked] = useState(false);
    const [file, setFile] = useState(null);
    const [isChecked, setChecked] = useState(null);
    const [brandDropdownList, setBrandDropdownList] = useState([]);
    const [urlParam, setUrlParam] = useState('');
    const [isSaveClicked, setSaveClick] = useState(false);
    const [isOverviewClicked, setOverviewClick] = useState(true);
    const [isSettingsClicked, setSettingsClick] = useState(false);
    // const [isCursorPicker, setCursorPicker] = useState(false);
    const [taskDetailsArray, setTaskDetailsArray] = useState(null);
    const [useBrandColor, setUseBrandColor] = useState(false);
    const [entityDetails, setEntityDetails] = useState(null);
    const [entityResponse, setEntityResponse] = useState(null);
    const [error, setError] = useState('');
    const [open, setOpen] = useState(null);
    const [fiveFilesList, setFiveFilesList] = useState([]);
    const [filesList, setFilesList] = useState([]);
    const [sortstate, setSort] = useState(false);
    const [showAllFile, setShowAllFile] = useState(false);
    const [deleteFileId, setDeleteFileId] = useState(null);
    const [deleteFile, setDeleteFile] = useState(false);
    const [overlayloader, setOverlayLoader] = useState(false);
    const [taskToggle, setTaskToggle] = useState(false);
    const userRole = useSelector((state) => state.role);
    const [tooltipMessage, setTooltipMessage] = useState("Copy Link")
    const [sortValues, setSortValues] = useState({
        sortBy: null,
        sortType: null
    })
    const [isLoading, setLoading] = useState(true);
    const [showDeleteFile, setShowDeleteFile] = useState(false);
    const handleCloseFilePopup = () => setShowDeleteFile(false);
    const handleShowFilePopup = () => setShowDeleteFile(true);
    const [stateList, setStateList] = useState([]);
    const [showUploadPopup, setShowUploadPopup] = useState(false);
    const [loadend, setLoadEnd] = useState(false);
    const [uploaderror, setUploaderror] = useState('');
    const [created, setCreate] = useState(false);
    const [uploadstate, setUpload] = useState(null);
    const [csmLabel, setCSMLabel] = useState('Select CSM');
    const [csmList, setCSMList] = useState([]);
    const [showNotes, setShowNotes] = useState(false);
    const [showMore, setShowMore] = useState(false);
    const [labelStart, setLabelStart] = useState('Select Date');
    const [labelEnd, setLabelEnd] = useState('Select Date');
    const [labelOpen, setLabelOpen] = useState('Select Date');
    const [audienceLabel, setAudienceLabel] = useState('Select');

    var files = showAllFile ? filesList : fiveFilesList;
    
    const [pickerValues, setPickervalues] = useState({
        isPrimaryClicked: true,
        isSecondaryClicked: false,
        pickedPrimaryColor: "#4A4A4A",
        pickedSecondaryColor: "#4A4A4A"
    });
    const [hexValues, setHexValues] = useState({
        primary: "#4A4A4A",
        secondary: "#4A4A4A"
    });
    const params = new URLSearchParams(location.search);

    const [values, setValues] = useState({
        id: null,
        logoUrl: upload_placeholder,
        name: null,
        address: null,
        emailId: null,
        country: "Select Country",
        countryCode: "+1",
        phoneNumber: null,
        zipcode: "",
        primaryColor: null,
        secondaryColor: null,
        font1: "Select Font1",
        font2: "Select Font2",
        mailingAddress: null,
        website: null,
        brandAssociated : "Select a Brand",
        associatedBrandId: null,
        propertyCode: null,
        tasks: null,
        state: "",
        city: "",
        description: null,
        fromEmail: null,
        csmId: null,
        ctyhocn: null,
        start: null,
        end: null,
        contractStatus: null,
        region: null,
        brandPortfolio: null,
        managementType: null,
        managementCompanyRecord: null,
        operationalOwnershipGroup: null,
        locationType: null,
        openDate: null,
        guestRooms: null,
        status: null,
        rlAudience: false,
        sisterProperties: null,
        membershipLocal: null,
        membershipResort: null,
        membershipServices: null
    });

    const phonewrapperRef = useRef(null);
    const countrywrapperRef = useRef(null);
    const brandwrapperRef = useRef(null);
    const font1wrapperRef = useRef(null);
    const font2wrapperRef = useRef(null);

    const [countryCodeDropdownClick, setcountryCodeDropdownClick] = useState(false);
    const [countryDropdownClick, setcountryDropdownClick] = useState(false);
    const [brandDropdownClick, setbrandDropdownClick] = useState(false);
    const [font1DropdownClick, setfont1DropdownClick] = useState(false);
    const [font2DropdownClick, setfont2DropdownClick] = useState(false);


    ClickOutsidePhone(phonewrapperRef, setcountryCodeDropdownClick);
    ClickOutsideCountry(countrywrapperRef, setcountryDropdownClick);
    ClickOutsideBrand(brandwrapperRef, setbrandDropdownClick);
    ClickOutsidefont1(font1wrapperRef, setfont1DropdownClick);
    ClickOutsidefont2(font2wrapperRef, setfont2DropdownClick);

    const createNewBrandValues = {
        page: "create-brand",
        header1: "Create New Portal",
        header2: "Customize Portal",
        data: null
    }
    const editBrandValues = {
        page: "edit-brand",
        header1: "Edit Portal",
        header2: "Customize Portal",
        data: null
    }
    const overviewBrandValues = {
        page: "overview-brand",
        header1: "Portal Info",
        header2: "Customize Portal",
        data: null
    }
    const createNewEntityValues = {
        page: "create-entity",
        header1: "Create New Property",
        header2: "Customize Property",
        data: null
    }
    const editEntityValues = {
        page: "edit-entity",
        header1: "Edit Property",
        header2: "Customize Property",
        data: null
    }
    const overviewEntityValues = {
        page: "overview-entity",
        header1: "Property Info",
        header2: "Customize Property",
        data: null
    }

    const handleUploadPopupClose = () => setShowUploadPopup(false);

    useLayoutEffect(() => {
        const location = window.location.href;
        if (location.includes('#files')) {
          const section = location.substring(location.indexOf('#') + 1);
          console.log("section", section);
          const targetElement = document.getElementById(`${section}`);
          if (targetElement) {
            targetElement.scrollIntoView({
              behavior: 'smooth'
            });
          }
        } else {
          window.scroll(0, 0);
        }
      }, []); 

    useEffect(() => {
        // Finding the section between brands and entities
        var param = "";
        if(path.includes('portals')) {
            param = "brands";
        } else {
            param = "entities";
        }
        setUrlParam(param);
        
        if(pageType == 'new') {
            parsedValues = (param == "brands") ? createNewBrandValues : createNewEntityValues;
            const breadcrumbsList = getBreadcrumbs();
            dispatch(parseBreadcrumbsList(breadcrumbsList));
        } else if(pageType == 'edit') {
            parsedValues = (param == "brands") ? editBrandValues : editEntityValues;
        } else if(pageType == 'view') {
            parsedValues = (param == "brands") ? overviewBrandValues : overviewEntityValues;
        }
        setPageData(parsedValues);

        const callApi = (accesstoken) => {
            if(accesstoken === '') {
                navigate('/login');
            }
            else if(accesstoken === 'noToken') {
                navigate('/login', {state : {path : window.location.pathname+window.location.search+window.location.hash}});
            }
            else {
                //Get Details API call
                if(parsedValues.page == 'edit-brand' || parsedValues.page == 'overview-brand') {
                    getResponse.GetBrandDetails(`/api/brand/detail?brandId=${id}`, accesstoken, (data) => {
                        if (data.status == 200) {
                            setLoading(false);
                            parsedValues.data = data.data.data;
                            getParsedData('brand');
                            const breadcrumbsList = getBreadcrumbs();
                            dispatch(parseBreadcrumbsList(breadcrumbsList));
                        } else if(data.status == 401) {
                            navigate("/login")
                        }
                    });
                } else if(parsedValues.page == 'edit-entity' || parsedValues.page == 'overview-entity') {
                    getResponseEntity.GetEntityDetails(`/api/entity/detail?IdEntities=${id}`, accesstoken, (data) => {
                        if (data.status == 200) {
                            setLoading(false);
                            parsedValues.data = data.data.data;
                            setEntityResponse(data.data.data);
                            getParsedData('entity');
                            const breadcrumbsList = getBreadcrumbs();
                            dispatch(parseBreadcrumbsList(breadcrumbsList));
                        } else if(data.status == 401) {
                            navigate("/login")
                        }
                    });
                }

                // Getting the brand list
                if(parsedValues.page == "create-entity" || parsedValues.page == "edit-entity" 
                || parsedValues.page == "overview-entity") {
                    console.log("Brand Associated", parsedValues.page);
                    getResponseEntity.GetBrandList('/api/brand/dropdown', accesstoken, (data) => {
                        if(data.status == 200) {
                            setBrandDropdownList(data.data.data);
                        } else if(data.status == 401) {
                            navigate("/login")
                        }
                    })
                }
            }
        }

        RefreshToken((accesstoken) => callApi(accesstoken));

        setPage(parsedValues.page);

        // Get country code array
        getCountryCodeArray();

        // Get country name array
        setCountryNames(getCountryNameArray());

        setStateList(getStateList())

        getCSMList();
    }, [])

    function getCSMList() {
        function CallAPI(accesstoken) {
            if(accesstoken === '') {
                navigate('/login');
            }
            else {
                getCommonResponse.GetDetailsWithToken('/api/entity/csmlist', accesstoken, (data) => {
                    if(data.status == 200) {
                        var csmArray = [];
                        data.data.data != null && data.data.data.length > 0 && data.data.data.map((item) => {
                            const csmObject = {id: 0, name: ''}
                            csmObject.id = item["idCSM"];
                            csmObject.name = item["firstName"]+" "+item["lastName"];
                            csmArray.push(csmObject);
                        })
                        setCSMList(csmArray);
                    } else if(data.status == 401) {
                        navigate("/login")
                    }
                })
            }
        }
        RefreshToken((accesstoken) => CallAPI(accesstoken));
    }

    useEffect(() => {
        setLoading(false);
        const callApi = (accesstoken) => {
            if(accesstoken == '') {
                navigate('/');
            } else {
                if(page == "overview-brand" || page == "edit-brand" || page == "overview-edit-brand") {
                    const URL = `/api/Brand/${id}/files${sortValues.sortBy ? `?sort_by=${sortValues.sortBy}` : ''}${sortValues.sortType ? `&sort_type=${sortValues.sortType}` : ''}`
                    getFileList(URL, accesstoken)
                } else if(page == "overview-entity" || page == "edit-entity" || page == "overview-edit-entity") {
                    const URL = `/api/Entity/${id}/files${sortValues.sortBy ? `?sort_by=${sortValues.sortBy}` : ''}${sortValues.sortType ? `&sort_type=${sortValues.sortType}` : ''}`
                    getFileList(URL, accesstoken)
                }
            }
        }

        RefreshToken((accesstoken) => callApi(accesstoken));
    }, [sortstate, deleteFile, page, uploadstate])

    const getFileList = (endpoint, accesstoken) => {
        getResponse.GetBrandFilesList(endpoint, accesstoken, (data) => {
            if(data.status == 200) {
                if(data.data.data.length <= 5) {
                    setFiveFilesList(data.data.data);
                    setFilesList(data.data.data);
                } else {
                    var files = [];
                    for(var i = 0; i < 5; i++) {
                        files.push(data.data.data[i])
                    }
                    setFiveFilesList(files);
                    setFilesList(data.data.data);
                }
            } else if(data.status == 401) {
                navigate("/login")
            }
        })
    }

    const getBreadcrumbs = () => {
        var breadcrumbsList = []
        if(parsedValues.page == "create-brand") {
            breadcrumbsList = [
                { "name": "Home", "url": "" },
                { "name": "Portals", "url": "portals/list" },
                { "name": "Portals New", "url": "portals/new" }
            ];
        } else if (parsedValues.page == "edit-brand") {
            breadcrumbsList = [
                { "name": "Home", "url": "" },
                { "name": "Portals", "url": "portals/list" },
                { "name": `${parsedValues.data.name}: Edit`, "url": `portals/${parsedValues.data.idBrand}/edit` }
            ];
        } else if(parsedValues.page == "overview-brand") {
            breadcrumbsList = [
                { "name": "Home", "url": "" },
                { "name": "Portals", "url": "portals/list" },
                { "name": parsedValues.data.name, "url": `portals/${parsedValues.data.idBrand}/view` }
            ];
        } else if(parsedValues.page == "create-entity") {
            breadcrumbsList = [
                { "name": "Home", "url": "" },
                { "name": "Properties", "url": "properties/list" },
                { "name": "Properties New", "url": "properties/new" }
            ];
        } else if(parsedValues.page == "edit-entity") {
            breadcrumbsList = [
                { "name": "Home", "url": "" },
                { "name": "Properties", "url": "properties/list" },
                { "name": `${parsedValues.data.name}: Edit`, "url": `properties/${parsedValues.data.idEntities}/edit` }
            ];
        } else if(parsedValues.page == "overview-entity") {
            breadcrumbsList = [
                { "name": "Home", "url": "" },
                { "name": "Properties", "url": "properties/list" },
                { "name": parsedValues.data.name, "url": `properties/${parsedValues.data.idEntities}/view` }
            ];
        }
        return breadcrumbsList;
    }

    const getParsedData = (page) => {
        const data = parsedValues.data;
        setValues({
            ...values,
            id: (page == 'brand') ? data.idBrand : data.idEntities,
            logoUrl: (data.logoUrl != "" && data.logoUrl != null) ? data.logoUrl : null,
            name: data.name,
            address: data.address,
            emailId: data.email,
            country: (data.country != null && data.country != "") ? data.country : "Select Country",
            countryCode: data.countryCode,
            phoneNumber: data.phoneNumber,
            zipcode: data.zipCode != null ? data.zipCode : '',
            primaryColor: data.primaryColor,
            secondaryColor: data.secondaryColor,
            font1: (data.font1 != null && data.font1 != "") ? data.font1 : "Select Font1",
            font2: (data.font2 != null && data.font2 != "") ? data.font2 : "Select Font2",
            mailingAddress: data.mailingAdress,
            website: data.website,
            brandAssociated : data.brand != null ? data.brand.name : null,
            associatedBrandId: data.brand != null ? data.brand.idBrand : null,
            propertyCode: data.propertyCode,
            tasks: data.tasks,
            state: (data.state != null && data.state != "") ? data.state : "",
            city: data.city != null ? data.city : '',
            description: data.description,
            fromEmail: data.fromEmail != null ? data.fromEmail : null,
            csmId: data.csm != null ? (data.csm.idCSM) : null,
            ctyhocn: data.ctyhocn,
            start: data.start != null ? new Date(data.start) : null,
            end: data.end != null ? new Date(data.end) : null,
            contractStatus: data.contractStatus,
            region: data.region,
            brandPortfolio: data.brandPortfolio,
            managementType: data.managementType,
            managementCompanyRecord: data.managementCompanyRecord,
            operationalOwnershipGroup: data.operationalOwnershipGroup,
            locationType: data.locationType,
            openDate: data.openDate != null ? new Date(data.openDate) : null,
            guestRooms: data.guestRooms,
            status: data.status,
            rlAudience: data.rlAudience,
            sisterProperties: data.sisterProperties,
            membershipLocal: data.membershipLocal,
            membershipResort: data.membershipResort,
            membershipServices: data.membershipServices
        })
        setChecked(data.useBrandColorAndFont);
        setEntityDetails(data);
        setUseBrandColor(data.useBrandColorAndFont);
        setCSMLabel(data.csm != null ? (data.csm.firstName+" "+data.csm.lastName) : "Select CSM")
        setAudienceLabel(data.rlAudience != null ? (data.rlAudience ? "Yes" : "No") : "Select")
        setLabelStart(data.start != null ? convertToDateString(new Date(data.start), "picker") : "Select Date")
        setLabelEnd(data.end != null ? convertToDateString(new Date(data.end), "picker") : "Select Date")
        setLabelOpen(data.openDate != null ? convertToDateString(new Date(data.openDate), "picker") : "Select Date")
        setPickervalues({
            ...pickerValues,
            pickedPrimaryColor: data.primaryColor != "" && data.primaryColor != null ? data.primaryColor : "#4A4A4A",
            pickedSecondaryColor: data.secondaryColor != "" && data.secondaryColor != null ? data.secondaryColor : "#4A4A4A"
        })
        setHexValues({
            primary: data.primaryColor != "" && data.primaryColor != null ? data.primaryColor : "#4A4A4A",
            secondary: data.secondaryColor != "" && data.secondaryColor != null ? data.secondaryColor : "#4A4A4A"
        })
    }

    useEffect(() => {
        if(page.includes('entity')) {
            if(entityDetails != null) {
                if(!useBrandColor) {
                    setPickervalues({
                        ...pickerValues,
                        pickedPrimaryColor: entityDetails.primaryColor != "" && entityDetails.primaryColor != null ? entityDetails.primaryColor : "#4A4A4A",
                        pickedSecondaryColor: entityDetails.secondaryColor != "" && entityDetails.secondaryColor != null ? entityDetails.secondaryColor : "#4A4A4A"
                    })
                    setValues({
                        ...values,
                        font1: entityDetails.font1,
                        font2: entityDetails.font2
                    })
                }
            }
        }
    }, [useBrandColor, entityDetails])

    const getCountryCodeArray = () => {
        const countryCallingCodeArray = [];
        Object.keys(countryCallingCodeObject).forEach((key) => {
            if(!countryCallingCodeArray.includes(countryCallingCodeObject[key])) {
                countryCallingCodeArray.push(countryCallingCodeObject[key].replace(/ /g, ''));
            }
        });
        setCallingCodes(countryCallingCodeArray.sort());
    }

    const handleImageUpload = e => {
        const [file] = e.target.files;
        setFile(file);
        if (file) {
          const reader = new FileReader();
          reader.onload = e => {
            setValues({
                ...values,
                logoUrl: e.target.result
            })
          };
          reader.readAsDataURL(file);
        }
    };

    const getFormData = (id, type) => {
        const formData = new FormData();
        if(type == 'brand') {
            formData.set('BrandId', id);
        } else {
            formData.set('EntityId', id);
        }
        formData.set('Logo', file)
        return formData
    }

    const handleName = (name) => {
        setValues({
            ...values,
            name: name
        })
    }

    const handleAddress = (address) => {
        setValues({
            ...values,
            address: address
        })
    }

    const handleEmailId = (email) => {
        setValues({
            ...values,
            emailId: email
        })
    }

    const handleCountryDropdown = () => {
        setcountryDropdownClick(!countryDropdownClick);
    }

    const getCountry = (e) => {
        console.log('country', e.target.innerText);
        setValues({
            ...values,
            country: e.target.innerText
        })
        setcountryDropdownClick(!countryDropdownClick);
    }

    const handleCountryCodeDropdown = () => {
        setcountryCodeDropdownClick(!countryCodeDropdownClick);
    }

    const getCountryCode = (value) => {
        setValues({
            ...values,
            countryCode: value
        })
        let suggestions = [];
        if(value != "") {
            callingCodes.length > 0 && callingCodes.map((item) => {
                if(item.includes(value)) {
                    suggestions.push(item)
                }
            })
        }
        setCallingCodeSuggestions(suggestions);
        setcountryCodeDropdownClick(true);
    }

    const getCountryCodeFromSelection = (value) => {
        setValues({
            ...values,
            countryCode: value
        })
        setcountryCodeDropdownClick(false);
    }

    const handlePhoneNumber = (phone) => {
        setValues({
            ...values,
            phoneNumber: phone
        })
    }

    const handleZipcode = (zipcode) => {
        setValues({
            ...values,
            zipcode: zipcode
        })
    }

    const handleState = (state) => {
        setValues({
            ...values,
            state: state
        })
    }

    const handleCity = (city) => {
        setValues({
            ...values,
            city: city
        })
    }

    const handleBrandAssociatedDropdown = () => {
        setbrandDropdownClick(!brandDropdownClick);
    }

    const getBrandAssociated = (name, id) => {
        setChecked(true);
        setValues({
            ...values,
            brandAssociated: name,
            associatedBrandId: id
        })
        setbrandDropdownClick(!brandDropdownClick);
    }

    const handlePropertyCode = (propertyCode) => {
        setValues({
            ...values,
            propertyCode: propertyCode
        })
    }

    const handleDescription = (description) => {
        setValues({
            ...values,
            description: description
        })
    }

    const handlePrimaryColor = (primary) => {
        // setCursorPicker(false);
        setPickervalues({
            ...pickerValues,
            isPrimaryClicked: true,
            isSecondaryClicked: false,
            pickedPrimaryColor: primary
        })
        setHexValues({
            ...hexValues,
            primary: primary
        })
        setValues({
            ...values,
            primaryColor: primary
        })
    }

    const handleSecondaryColor = (secondary) => {
        // setCursorPicker(false);
        setPickervalues({
            ...pickerValues,
            isPrimaryClicked: false, 
            isSecondaryClicked: true,
            pickedSecondaryColor: secondary
        })
        setHexValues({
            ...hexValues,
            secondary: secondary
        })
        setValues({
            ...values,
            secondaryColor: secondary
        })
    }

    const handleFont1Dropdown = () => {
        setfont1DropdownClick(!font1DropdownClick);
    }

    const getFont1 = (e) => {
        setValues({
            ...values,
            font1: e.target.innerText
        })
        setfont1DropdownClick(!font1DropdownClick);
    }

    const handleFont2Dropdown = () => {
        setfont2DropdownClick(!font2DropdownClick);
    }

    const getFont2 = (e) => {
        setValues({
            ...values,
            font2: e.target.innerText
        })
        setfont2DropdownClick(!font2DropdownClick);
    }

    const handleMailingAddress = (mailing) => {
        setValues({
            ...values,
            mailingAddress: mailing
        })
    }

    const handleFromEmail = (email) => {
        setValues({
            ...values,
            fromEmail: email
        })
    }

    const handleCSMDropdown = (id) => {
        setValues({
            ...values,
            csmId: id
        })
    }

    const handleWebsite = (website) => {
        setValues({
            ...values,
            website: website
        })
    }

    const callAddDetailsApi = () => {
        setEnable(false);
        setSaveClick(true);
        const details = updateValues('add', null);
        
        const callApi = (accesstoken) => {
            if(accesstoken === '') {
                navigate('/login');
            }
            else if(accesstoken === 'noToken') {
                navigate('/login', {state : {path : window.location.pathname+window.location.search+window.location.hash}});
            }
            else {
                if(pageData.page == "create-brand") {
                    getResponse.AddNewBrand('/api/brand/add', accesstoken, details, (data) => {
                        setEnable(true);
                        if(data.status == 200) {
                            setOpen(false)
                            setLoading(true);
                            if(file != null) {
                                callUploadMediaApi(data.data.data.idBrand, 'brand', accesstoken)
                            } else {
                                navigate("/portals/list/");
                            }
                        }
                        if (data.status == 400) {
                            setLoading(false);
                            setOpen(true)
                            setError(data.data.message);
                            window.scroll(0,0);
                        } else if(data.status == 401) {
                            navigate("/login")
                        }
                    });
                } else if(pageData.page == "create-entity") {
                    getResponseEntity.AddNewEntity('/api/entity/add', accesstoken, details, (data) => {
                        setEnable(true);
                        if(data.status == 200) {
                            setOpen(false)
                            setLoading(true);
                            if(file != null) {
                                callUploadMediaApi(data.data.data.idEntities, 'entity', accesstoken)
                            } else {
                                navigate("/properties/list/");
                            }
                        }
                        if (data.status == 400) {
                            setLoading(false);
                            setOpen(true)
                            setError(data.data.message);
                            window.scroll(0,0);
                        } else if(data.status == 401) {
                            navigate("/login")
                        }
                    });
                }
            }
        }

        RefreshToken((accesstoken) => callApi(accesstoken));
    }

    useEffect(() => {
        if(isChecked != null) {
            setOverlayLoader(true);
        }
        const callApi = (accesstoken) => {
            if(accesstoken === '') {
                navigate('/login');
            }
            else {
                if(page.includes('entity')) {
                    if(isChecked) {
                        // Get the selected brand details
                        getResponse.GetBrandDetails(`/api/brand/detail?brandId=${values.associatedBrandId}`, accesstoken, (data) => {
                            setOverlayLoader(false);
                            if (data.status == 200) {
                                const response = data.data.data;
                                setValues({
                                    ...values,
                                    primaryColor: response.primaryColor,
                                    secondaryColor: response.secondaryColor,
                                    font1: response.font1,
                                    font2: response.font2,
                                })
            
                                setPickervalues({
                                    ...pickerValues,
                                    pickedPrimaryColor: response.primaryColor != "" && response.primaryColor != null ? response.primaryColor : "#4A4A4A",
                                    pickedSecondaryColor: response.secondaryColor != "" && response.secondaryColor != null ? response.secondaryColor : "#4A4A4A"
                                })
                            } else if(data.status == 401) {
                                navigate("/login")
                            }
                        });
                    } else {
                        setOverlayLoader(false);
                        if(page == "create-entity") {
                            setValues({
                                ...values,
                                primaryColor: null,
                                secondaryColor: null,
                                font1: "Select Font1",
                                font2: "Select Font2",
                            })
                
                            setPickervalues({
                                ...pickerValues,
                                pickedPrimaryColor: "#4A4A4A",
                                pickedSecondaryColor: "#4A4A4A"
                            })
                        } else {
                            setValues({
                                ...values,
                                primaryColor: entityResponse.primaryColor != null ? entityResponse.primaryColor : "#4A4A4A",
                                secondaryColor: entityResponse.secondaryColor != null ? entityResponse.secondaryColor : "#4A4A4A",
                                font1: entityResponse.font1 != null ? entityResponse.font1 : "Select Font1",
                                font2: entityResponse.font2 != null ? entityResponse.font2 : "Select Font2",
                            })
                
                            setPickervalues({
                                ...pickerValues,
                                pickedPrimaryColor: entityResponse.primaryColor != null ? entityResponse.primaryColor : "#4A4A4A",
                                pickedSecondaryColor: entityResponse.secondaryColor != null ? entityResponse.secondaryColor : "#4A4A4A"
                            })
                        }
                    }   
                }
            }
        }

        RefreshToken((accesstoken) => callApi(accesstoken));

    }, [values.associatedBrandId, isChecked])

    const updateValues = (type, url) => {
        const details = {
            Name: trim(values.name),
            LogoUrl: url,
            Email: trim(values.emailId),
            CountryCode: values.countryCode,
            PhoneNumber: trim(values.phoneNumber),
            Address: trim(values.address),
            ZipCode: values.zipcode === "" ? null : trim(values.zipcode),
            Country: values.country != "Select Country" ? values.country : null,
            PrimaryColor: values.primaryColor,
            SecondaryColor: values.secondaryColor,
            Font1: values.font1 != "Select Font1" ? values.font1: null,
            Font2: values.font2 != "Select Font2" ? values.font2: null,
            Website: trim(values.website),
            MailingAdress: values.mailingAddress,
            State: values.state != "" ? values.state : null,
            City: values.city != null ? trim(values.city) : null,
        }
        if(type == 'edit') {
            if(urlParam == "brands") {
                details.IdBrand = values.id
            } else {
                details.IdEntities = values.id
            }
        }
        if(urlParam == "entities") {
            details.BrandId = values.associatedBrandId
            details.UseBrandColorAndFont = isChecked
            details.PropertyCode = trim(values.propertyCode)
            details.Description = trim(values.description)
            details.FromEmail = values.fromEmail
            details.CSMId = values.csmId != null ? values.csmId : null
            details.CTYHOCN = trim(values.ctyhocn)
            details.Start = values.start ? convertToDateString(values.start, "") : null
            details.End = values.end ? convertToDateString(values.end, "") : null
            details.ContractStatus = trim(values.contractStatus)
            details.Region = trim(values.region)
            details.BrandPortfolio = trim(values.brandPortfolio)
            details.ManagementType = trim(values.managementType)
            details.ManagementCompanyRecord = trim(values.managementCompanyRecord)
            details.OperationalOwnershipGroup = trim(values.operationalOwnershipGroup)
            details.LocationType = trim(values.locationType)
            details.OpenDate = values.openDate ? convertToDateString(values.openDate, "") : null
            details.GuestRooms = parseInt(values.guestRooms)
            details.Status = values.status
            details.RLAudience = values.rlAudience
            details.SisterProperties = trim(values.sisterProperties)
            details.MembershipLocal = trim(values.membershipLocal)
            details.MembershipResort = trim(values.membershipResort)
            details.MembershipServices = trim(values.membershipServices)
        } else {
            details.Tasks = taskDetailsArray
        }
        return details
    }

    const callUpdateDetailsApi = () => {
        setEnable(false);
        setSaveClick(true);
        var details = null;

        const callApi = (accesstoken) => {
            if(accesstoken === '') {
                navigate('/login');
            }
            else {
                if(page == "edit-brand") {
                    if(file != null) {
                        const formData = getFormData(values.id, 'brand');
                        getResponse.UploadMedia('/api/brand/logo/upload', accesstoken, formData, (data) => {
                            if(data.status == 200) {
                                details = updateValues('edit', data.data.logoUrl);
                                getResponse.EditBrand('/api/brand/update', accesstoken, details, (data) => {
                                    setEnable(true);
                                    if (data.status == 200) {
                                        setLoading(true);
                                        setOpen(false)
                                        navigate("/portals/list/");
                                    }
                                    if (data.status == 400) {
                                        setLoading(false);
                                        setOpen(true)
                                        setError(data.data.message);
                                        window.scroll(0,0);
                                    } else if(data.status == 401) {
                                        navigate("/login")
                                    }
                                });
                            } else if(data.status == 401) {
                                navigate("/login")
                            }
                        })
                    } else {
                        details = updateValues('edit', values.logoUrl);
                        getResponse.EditBrand('/api/brand/update', accesstoken, details, (data) => {
                            setEnable(true);
                            if (data.status == 200) {
                                setLoading(true);
                                navigate("/portals/list/");
                                setOpen(false)
                            }
                            if (data.status == 400) {
                                setLoading(false);
                                setOpen(true)
                                setError(data.data.message);
                                window.scroll(0,0);
                            } else if(data.status == 401) {
                                navigate("/login")
                            }
                        });
                    }
                } else if(page == "overview-edit-brand") {
                    if(file != null) {
                        const formData = getFormData(values.id, 'brand');
                        getResponse.UploadMedia('/api/brand/logo/upload', accesstoken, formData, (data) => {
                            if(data.status == 200) {
                                details = updateValues('edit', data.data.logoUrl);
                                getResponse.EditBrand('/api/brand/update', accesstoken, details, (data) => {
                                    if (data.status == 200) {
                                        setLoading(true);
                                        getBrandList(accesstoken);
                                        setOpen(false)
                                        setError('');
                                    }
                                    if (data.status == 400) {
                                        setLoading(false);
                                        setOpen(true)
                                        setError(data.data.message);
                                        window.scroll(0,0);
                                    } else if(data.status == 401) {
                                        navigate("/login")
                                    }
                                });
                            } else if(data.status == 401) {
                                navigate("/login")
                            }
                        })
                    } else {
                        details = updateValues('edit', values.logoUrl);
                        getResponse.EditBrand('/api/brand/update', accesstoken, details, (data) => {
                            if (data.status == 200) {
                                setLoading(true);
                                getBrandList(accesstoken);
                                setError('');
                                setOpen(false)
                            }
                            if (data.status == 400) {
                                setLoading(false);
                                setOpen(true)
                                setError(data.data.message);
                                window.scroll(0,0);
                            } else if(data.status == 401) {
                                navigate("/login")
                            }
                        });
                    }
                } else if(page == "edit-entity") {
                    if(file != null) {
                        const formData = getFormData(values.id, 'entity');
                        getResponseEntity.UploadMedia('/api/entity/logo/upload', accesstoken, formData, (data) => {
                            if(data.status == 200) {
                                details = updateValues('edit', data.data.logoUrl);
                                getResponse.EditBrand('/api/entity/update', accesstoken, details, (data) => {
                                    setEnable(true);
                                    if (data.status == 200) {
                                        setLoading(true);
                                        navigate("/properties/list/");
                                        setOpen(false)
                                    }
                                    if (data.status == 400) {
                                        setLoading(false);
                                        setOpen(true)
                                        setError(data.data.message);
                                        window.scroll(0,0);
                                    } else if(data.status == 401) {
                                        navigate("/login")
                                    }
                                });
                            } else if(data.status == 401) {
                                navigate("/login")
                            }
                        })
                    } else {
                        details = updateValues('edit', values.logoUrl);
                        getResponse.EditBrand('/api/entity/update', accesstoken, details, (data) => {
                            setEnable(true);
                            if (data.status == 200) {
                                setLoading(true);
                                setOpen(false)
                                navigate("/properties/list/");
                            }
                            if (data.status == 400) {
                                setLoading(false);
                                setOpen(true)
                                setError(data.data.message);
                                window.scroll(0,0);
                            } else if(data.status == 401) {
                                navigate("/login")
                            }
                        });
                    }
                } else if(page == "overview-edit-entity") {
                    if(file != null) {
                        const formData = getFormData(values.id, 'entity');
                        getResponseEntity.UploadMedia('/api/entity/logo/upload', accesstoken, formData, (data) => {
                            if(data.status == 200) {
                                details = updateValues('edit', data.data.logoUrl);
                                getResponseEntity.EditEntity('/api/entity/update', accesstoken, details, (data) => {
                                    if (data.status == 200) {
                                        setLoading(true);
                                        setOpen(false)
                                        getEntityList(accesstoken);
                                        setError('');
                                    }
                                    if (data.status == 400) {
                                        setLoading(false);
                                        setOpen(true)
                                        setError(data.data.message);
                                        window.scroll(0,0);
                                    } else if(data.status == 401) {
                                        navigate("/login")
                                    }
                                });
                            } else if(data.status == 401) {
                                navigate("/login")
                            }
                        })
                    } else {
                        details = updateValues('edit', values.logoUrl);
                        getResponseEntity.EditEntity('/api/entity/update', accesstoken, details, (data) => {
                            if (data.status == 200) {
                                setLoading(true);
                                getEntityList(accesstoken);
                                setError('');
                                setOpen(false)
                            }
                            if (data.status == 400) {
                                setLoading(false);
                                setOpen(true)
                                setError(data.data.message);
                                window.scroll(0,0);
                            } else if(data.status == 401) {
                                navigate("/login")
                            }
                        });
                    }
                }
            }
        }

        RefreshToken((accesstoken) => callApi(accesstoken));
    }

    const callUploadMediaApi = (id, type, accesstoken) =>{
        const formData = getFormData(id, type);
        getResponse.UploadMedia(`/api/${type}/logo/upload`, accesstoken, formData, (data) => {
            if(data.status == 200) {
                if(type == 'brand') {
                    navigate("/portals/list/");
                } else {
                    navigate("/properties/list/");
                }
                // window.location.reload();
            } else if(data.status == 401) {
                navigate("/login")
            }
        })
    }

    const getBrandList = (accesstoken) => {
        getResponse.GetBrandDetails(`/api/brand/detail?brandId=${values.id}`, accesstoken, (data) => {
            if (data.status == 200) {
                setLoading(false)
                // setPageData(data.data.data);
                setEditClicked(!editCliked);
                setTaskToggle(!taskToggle);
                setPage("overview-brand");
                navigate(`/portals/${values.id}/view`);
            } else if(data.status == 401) {
                navigate("/login")
            }
        });
    }

    const getEntityList = (accesstoken) => {
        getResponseEntity.GetEntityDetails(`/api/entity/detail?IdEntities=${values.id}`, accesstoken, (data) => {
            if (data.status == 200) {
                setLoading(false)
                // setPageData(data.data.data);
                setEntityResponse(data.data.data);
                setEditClicked(!editCliked);
                setTaskToggle(!taskToggle);
                setPage("overview-entity");
                navigate(`/properties/${values.id}/view`);
            } else if(data.status == 401) {
                navigate("/login")
            }
        });
    }

    const handleEdit = () => {
        setTaskToggle(!taskToggle);
        setEditClicked(!editCliked);
        if(page == "overview-brand") {
            setPage("overview-edit-brand");
        } else {
            setPage("overview-edit-entity");
            setUseBrandColor(entityDetails.useBrandColorAndFont);
        }
    }

    const handleSave = () => {
        callUpdateDetailsApi();
    }

    const handleCheckbox = () => {
        setChecked(!isChecked);
    }

    const handleTaskDetails = (taskList) => {
        console.log("Final details", taskList)
        const taskArray = [];
        var taskDetailsObject = null;
        taskList != null && taskList.map((item) => {
            if(page == "create-entity" || page == "create-brand") {
                taskDetailsObject = {
                    ProjectTypeId: null, 
                    TaskTemplateTaskRelations: []
                }

                taskDetailsObject.ProjectTypeId = item["projectTypeId"]
                item["taskTemplateTaskRelations"] != null && item["taskTemplateTaskRelations"].length > 0 && item["taskTemplateTaskRelations"].map((subitem) => {
                    var taskObject = {
                        Order: null, 
                        TaskName: null
                    }
                    taskObject.Order = subitem["order"]
                    taskObject.TaskName = trim(subitem["taskName"])

                    taskDetailsObject.TaskTemplateTaskRelations.push(taskObject);
                })
            } else {
                taskDetailsObject = {
                    IdTaskTemplateBrandRelation: null,
                    ProjectTypeId: null, 
                    TaskTemplateTaskRelations: []
                }

                taskDetailsObject.IdTaskTemplateBrandRelation = item["idTaskTemplateBrandRelation"]
                taskDetailsObject.ProjectTypeId = item["projectTypeId"]
                item["taskTemplateTaskRelations"] != null && item["taskTemplateTaskRelations"].length > 0 && item["taskTemplateTaskRelations"].map((subitem) => {
                    var taskObject = {
                        IdTaskTemplateTaskRelation: null,
                        Order: null, 
                        TaskName: null
                    }
                    taskObject.IdTaskTemplateTaskRelation = subitem["idTaskTemplateTaskRelation"]
                    taskObject.Order = subitem["order"]
                    taskObject.TaskName = trim(subitem["taskName"])

                    taskDetailsObject.TaskTemplateTaskRelations.push(taskObject);
                })
            }

            taskArray.push(taskDetailsObject);
        })
        setValues({
            ...values,
            tasks: taskList
        })
        setTaskDetailsArray(taskArray)
    }

    const handleOverview = () => {
        setOverviewClick(true);
        if(isSettingsClicked) {
            setSettingsClick(false);
        }
    }

    const handleSettings = () => {
        setSettingsClick(true);
        if(isOverviewClicked) {
            setOverviewClick(false);
        }
    }

    function SortFile(dataset) {
        setSortValues({
            sortBy: dataset.sortBy,
            sortType: dataset.sortType
        })
        if(dataset.sortType === 'asc') {
            setSort(!sortstate);
        } else {
            setSort(!sortstate);
        }
    }

    function ShowFile() {
        setShowAllFile(!showAllFile);
    }

    function DeleteFile(e, fileid) {
        e.stopPropagation();
        setDeleteFileId(fileid);
        handleShowFilePopup();
    }

    function callDeleteFileApi() {
        const URL = `/api/brand/file/delete/${deleteFileId}`
        function CallAPI(accesstoken) {
            if(accesstoken === '') {
                navigate('/login');
            }
            else {
                getResponse.DeleteFile(URL, accesstoken, (response) => {
                    if(response.status == 200) {
                        setDeleteFile(!deleteFile);
                        handleCloseFilePopup();
                    } else if(response.status == 401) {
                        navigate("/login")
                    }
                });
            }
        }
        RefreshToken((accesstoken) => CallAPI(accesstoken));
    }

    const handleMouseLeave = () => {
        setTooltipMessage("Copy Link")
    }

    const setStateLabel = (state) => {
        setValues({
            ...values,
            state: state
        })
    }

    const openUploadPopup = () => {
        setShowUploadPopup(true);
        setLoadEnd(false);
        setUploaderror('');
        setCreate(!created);
    }

    const handleNotes = () => {
        setShowNotes(true)
    }

    const handleShowMore = () => {
        setShowMore(!showMore);
    }

    const handleInputChange = (fieldName, value) => {
        setValues({
          ...values,
          [fieldName]: value
        });
    }

    return(
        <>
            <div className='create-new-container'>
                <Header/>

                <div className='row create-new-sub-container'>
                    <Sidebar/>

                    <div className='col-10 create-new-body-container'>
                        <div className='sub-header'>
                            <Breadcrumbs/>
                        </div>
                        {isLoading ? 
                            (<Spinner/>) : ( <>
    
                        {pageData != null && 
                        (
                            <LoadingOverlay active={overlayloader} spinner={false} classNamePrefix='loader_'>
                                <div className='create-new-sub-body-container'>
                                    {/* {(page == 'overview-entity' || page == 'overview-edit-entity') && 
                                        <div className='overview-settings-container'>
                                            {isOverviewClicked ? <div className='overview-header-clicked' onClick={handleOverview}>Overview</div> :
                                                <div className='overview-header' onClick={handleOverview}>Overview</div>}
                                            {isSettingsClicked ? <div className='settings-header-clicked' onClick={handleSettings}>Settings</div> :
                                                <div className='settings-header' onClick={handleSettings}>Settings</div>}
                                        </div>} */}

                                    {isOverviewClicked &&
                                    <>
                                        <div className='section1'>
                                            <div className='header-container'>
                                                <div className='create-new-header'>{pageData.header1}<span>{(page == "overview-brand" || page == "overview-edit-brand" || page =="edit-brand") && ` - ${id}`}</span></div>
                                                {((page == 'overview-brand' && userRole == 1) || (page == 'overview-edit-brand' && userRole == 1) || page == 'overview-entity' || page == 'overview-edit-entity') && 
                                                    <div className='edit'>{editCliked ? <div className='save-btn' onClick={handleSave}>Save</div> : 
                                                    <img src={edit} alt="Edit"  onClick={handleEdit}/>}</div>}
                                            </div>
                                            <div className='create-new-body'>
                                                <div className='sub-section1'>
                                                    <input type="file" accept="image/*" onChange={handleImageUpload} ref={imageUploader}/>
                                                    <div className='uploaded-logo'>
                                                        <img src={values.logoUrl} alt="Logo"/>
                                                    </div>
                                                    {(page != 'overview-brand' && page != 'overview-entity') && 
                                                        <div className='label' onClick={() => imageUploader.current.click()}>
                                                            Upload Logo
                                                        </div>          
                                                    }                           
                                                </div>
                                                <div className='sub-section2'>
                                                    <div className='name-field'>
                                                        {(page == "create-brand" || page == "edit-brand" || page == "overview-brand" || page == "overview-edit-brand") ?
                                                            <div className={`label ${!(page == "overview-entity" || page == "overview-brand") ? 'required label-color' : ''}`}>Portal Name</div> 
                                                            :
                                                            <div className={`label ${!(page == "overview-entity" || page == "overview-brand") ? 'required label-color' : ''}`}>Property Name</div>
                                                        }
                                                            {(page == 'overview-brand' || page == 'overview-entity') ? 
                                                                (<div className='overview-field'>{values.name}</div>) : 
                                                                (<input type="text" value={values.name} onChange={(e) => handleName(e.target.value)} maxLength={100}/>)}
                                                    </div>
                                                    <div className='state-field'>
                                                        <div className={`label ${!(page == "overview-entity" || page == "overview-brand") ? 'label-color' : ''}`}>State / Province</div>
                                                        {(page == 'overview-brand' || page == 'overview-entity') ? 
                                                            (<div className='overview-field'>{values.state && values.state != "" ? values.state : "--"}</div>) : 
                                                            (<div className='state-dropdown'>
                                                                <CityStatedropdown selectedItem={(name) => handleState(name)} handleLabel={(value) => setStateLabel(value)} list={stateList} label={values.state}/>
                                                            </div>)}
                                                    </div>
                                                    {(page == 'create-entity' || page == 'edit-entity' || page == 'overview-entity' || page == 'overview-edit-entity') && 
                                                        <div className={`brand-associated-field ${!(page == "overview-entity") ? 'field-margin' : ''}`} >
                                                            <div className={`label ${!(page == "overview-entity") ? 'required label-color' : ''}`} style={{marginBlockEnd: `${page == 'overview-entity' ? '0px' : '7px'}`}}>Brand Associated</div>
                                                            {page == 'overview-entity' ? 
                                                            <div className='overview-field'>{values.brandAssociated ? values.brandAssociated: "--"}</div> : 
                                                            <div className='dropdown brand-entity-dropdown' ref={brandwrapperRef}>
                                                                <div className='dropdown-name-img dropdown-brand-associated' onClick={handleBrandAssociatedDropdown}>
                                                                    <div className='dropdown-name'>{values.brandAssociated}</div>
                                                                    <div><img className='arrow' src={brandDropdownClick ? upArrow : downArrow} alt=""></img></div>
                                                                </div>
                                                                {brandDropdownClick &&
                                                                    <div className='dropdown-list'>
                                                                        {
                                                                            brandDropdownList.length > 0 && brandDropdownList.map((item, index) => {
                                                                                return (
                                                                                    <div className='dropdown-content-inner brand-associated-dropdown-inner' key={index} onClick={() => getBrandAssociated(item.name, item.idBrand)}>{item.name}</div>
                                                                                )
                                                                            })
                                                                        }
                                                                    </div>
                                                                }
                                                            </div>
                                                            }
                                                        </div>}
                                                </div>
                                                <div className='sub-section3'>
                                                    {/* <div className='email-field'>
                                                        <div className={`label ${!(page == "overview-entity" || page == "overview-brand") ? 'label-color' : ''}`}>Email Id</div>
                                                        {(page == 'overview-brand' || page == 'overview-entity') ?
                                                            (<div className='overview-field'>{values.emailId ? values.emailId: "--"}</div>) : 
                                                            (<input type="text" value={values.emailId} onChange={(e) => handleEmailId(e.target.value)}/>)}
                                                    </div> */}
                                                     <div className='address-field'>
                                                        <div className={`label ${!(page == "overview-entity" || page == "overview-brand") ? 'label-color' : ''}`}>Address</div>
                                                        {(page == 'overview-brand' || page == 'overview-entity') ?
                                                            (<div className='overview-field'>{values.address ? values.address : "--"}</div>) : 
                                                            (<input type="text" value={values.address} onChange={(e) => handleAddress(e.target.value)} maxLength={100}/>)}
                                                    </div>
                                                    <div className='zipcode-field'>
                                                        <div className={`label ${!(page == "overview-entity" || page == "overview-brand") ? 'label-color' : ''}`}>Zip / Postal Code</div>
                                                        {(page == 'overview-brand' || page == 'overview-entity') ? 
                                                            (<div className='overview-field'>{values.zipcode ? values.zipcode : "--"}</div>) : 
                                                            (<input type="text" maxLength={19} value={values.zipcode} onChange={(e) => handleZipcode(e.target.value)}/>)}
                                                    </div>
                                                    {(page == "create-entity" || page == "edit-entity" || page == "overview-entity" || page == 'overview-edit-entity') &&
                                                        <div className={`property-code-field`}>
                                                            <div className={`label ${!(page == "overview-entity") ? 'required label-color' : ''}`}>Property Code</div>
                                                            {page == "overview-entity" ? (<div className='overview-field'>{values.propertyCode ? values.propertyCode : "--"}</div>) :
                                                            <input type="text" value={values.propertyCode} onChange={(e) => handlePropertyCode(e.target.value)} maxLength={45}/>
                                                            }
                                                    </div>}
                                                </div>
                                                <div className='sub-section4'>
                                                    {/* <div className='phone-field'>
                                                        <div className={`label ${!(page == "overview-entity" || page == "overview-brand") ? 'label-color' : ''}`}>Phone Number</div>
                                                        <div className='calling-country-code'>
                                                            {(page == 'overview-brand' || page == 'overview-entity') ?
                                                                (<div className='overview-field'>{values.phoneNumber ? values.countryCode+" "+values.phoneNumber : "--"}</div>) : 
                                                                (
                                                                <>
                                                                    <div className='dropdown dropdown-country-code-container' ref={phonewrapperRef}>
                                                                        <div className='dropdown-country-code'>
                                                                            <input className='calling-code' value={values.countryCode} onChange={(e) => getCountryCode(e.target.value)}/>
                                                                        </div>
                                                                        {countryCodeDropdownClick &&
                                                                            <div className='dropdown-list'>
                                                                                {
                                                                                    callingCodeSuggestions.length > 0 && callingCodeSuggestions.map((item, index) => {
                                                                                        return (
                                                                                            <div className='dropdown-content-inner countrycode-dropdown-inner' key={index} 
                                                                                            onClick={(event) => getCountryCodeFromSelection(event.target.innerText)}>{item}</div>
                                                                                        )
                                                                                    })
                                                                                }
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                    <div><input className='phone-number' value={values.phoneNumber} type="text" onChange={(e) => handlePhoneNumber(e.target.value)}/></div>
                                                                </>)}
                                                        </div>
                                                    </div> */}
                                                    <div className='city-field'>
                                                        <div className={`label ${!(page == "overview-entity" || page == "overview-brand") ? 'label-color' : ''}`}>City</div>
                                                        {(page == 'overview-brand' || page == 'overview-entity') ? 
                                                            (<div className='overview-field'>{values.city ? values.city : "--"}</div>) : 
                                                            (<input type="text" value={values.city} onChange={(e) => handleCity(e.target.value)} maxLength={45}/>)}
                                                    </div>
                                                    <div className='country-field'>
                                                        <div className={`label ${!(page == "overview-entity" || page == "overview-brand") ? 'label-color' : ''}`} style={{marginBlockEnd: `${(page == 'overview-brand' || page == 'overview-entity') ? '0px' : '7px'}`}}>Country / Region</div>
                                                        {(page == 'overview-brand' || page == 'overview-entity') ?
                                                            (<div className='overview-field'>{values.country && values.country != "Select Country" ? values.country : "--"}</div>) : 
                                                            (<div className='dropdown brand-entity-dropdown' ref={countrywrapperRef}>
                                                                <div className='dropdown-name-img dropdown-country' onClick={handleCountryDropdown} >
                                                                    <div className='dropdown-name'>{values.country}</div>
                                                                    <div><img className='arrow' src={countryDropdownClick ? upArrow : downArrow} alt=""></img></div>
                                                                </div>
                                                                {countryDropdownClick &&
                                                                    <div className='dropdown-list'>
                                                                        {
                                                                            countryNames.length > 0 && countryNames.map((item, index) => {
                                                                                return (
                                                                                    <div className='dropdown-content-inner country-dropdown-inner' key={index} onClick={(event) => getCountry(event)}>{item}</div>
                                                                                )
                                                                            })
                                                                        }
                                                                    </div>
                                                                }
                                                            </div>)}
                                                    </div>
                                                    {(page == "create-entity" || page == "edit-entity" || page == "overview-entity" || page == 'overview-edit-entity') && 
                                                    <div className={`contract-status-field ${!(page == "overview-entity") ? 'field-margin' : ''}`}>
                                                        <div className={`label ${!(page == "overview-entity") ? 'label-color' : ''}`}>Contract Status</div>
                                                        {(page == 'overview-entity') ? 
                                                            (<div className='overview-field'>{values.contractStatus ? values.contractStatus : "--"}</div>) : 
                                                            (<input type="text" maxLength={45} value={values.contractStatus} onChange={(e) => handleInputChange("contractStatus", e.target.value)}/>)}
                                                    </div>}
                                                </div>
                                            </div>
                                            {(page == "create-entity" || page == "edit-entity" || page == "overview-entity" || page == 'overview-edit-entity') &&
                                                <div className='sister-properties-field'>
                                                    <div className={`label ${!(page == "overview-entity") ? 'label-color' : ''}`}>Sister Properties</div>
                                                    {page == "overview-entity" ? (<div className='overview-field'>{values.sisterProperties ? values.sisterProperties : "--"}</div>) :
                                                    <textarea type="text" maxLength={200} rows={2} value={values.sisterProperties} onChange={(e) => handleInputChange("sisterProperties", e.target.value)}></textarea>
                                                    }
                                            </div>}
                                            {(page == "create-entity" || page == "edit-entity" || page == "overview-entity" || page == 'overview-edit-entity') &&
                                                <div className='description-field'>
                                                    <div className={`label ${!(page == "overview-entity") ? 'label-color' : ''}`}>Description</div>
                                                    {page == "overview-entity" ? (<div className='overview-field'>{values.description ? values.description : "--"}</div>) :
                                                    <textarea type="text" maxLength={60000} rows={5} value={values.description} onChange={(e) => handleDescription(e.target.value)}/>
                                                    }
                                            </div>}
                                        </div>
                                        {(page == "create-brand" || page == "edit-brand" || page == "overview-brand" || page == "overview-edit-brand") && 
                                        <div className='section2'>
                                            <div className='customize-header'>{pageData.header2}</div>
                                            {(page == "create-entity" || page == "edit-entity" || page == "overview-edit-entity") &&
                                                <div className='checkbox brand-checkbox'>
                                                    <label>
                                                        <input type="checkbox" onChange={handleCheckbox} checked={isChecked}/>
                                                        <span class="checkmark brand-checkmark"></span>
                                                        <span className={`label ${!(page == "overview-entity" || page == "overview-brand") ? 'label-color' : ''}`}>Use Portal Colors And Fonts</span> 
                                                    </label>
                                                </div>
                                            }
                                            <div className='customize-body'>
                                                <div className='sub-section1'>
                                                    <div className='sub-header-container1'>
                                                        {(page == 'overview-brand' || page == 'overview-entity' || isChecked) ? 
                                                            (page == 'overview-brand' ? <div className='label'>Your Portal Colors</div> : 
                                                            <div className={`label ${!(page == "overview-entity" || page == "overview-brand") ? 'label-color' : ''}`}>Your Property Colors</div>) : 
                                                            ((page == "create-brand" || page == "edit-brand" || page == "overview-edit-brand") ? 
                                                            <div className={`label ${!(page == "overview-entity" || page == "overview-brand") ? 'label-color' : ''}`}>Select Your Portal Colors</div> : <div className={`label ${!(page == "overview-entity" || page == "overview-brand") ? 'label-color' : ''}`}>Select Your Property Colors</div>)}
                                                        {(page != 'overview-brand' && page != 'overview-entity' && !isChecked) && <div className='note'>(2 Colors Maximum)</div>}
                                                    </div>
                                                    {(page == 'overview-brand' || page == 'overview-entity' || isChecked) ?
                                                        (<div className='overview-color-picker-container'>
                                                            <div className='primary-color-container'>
                                                                <div className={`label ${!(page == "overview-entity" || page == "overview-brand") ? 'label-color' : ''}`}>Primary Color</div>
                                                                <div className='values-container'>
                                                                    <div className='picked-color' id='picked-color-primary' style={{backgroundColor: `${pickerValues.pickedPrimaryColor}`}}></div>
                                                                    <div className='hex-code'>{pickerValues.pickedPrimaryColor ? pickerValues.pickedPrimaryColor : "--"}</div>
                                                                </div>
                                                            </div>
                                                            <div className='secondary-color-container'>
                                                                <div className={`label ${!(page == "overview-entity" || page == "overview-brand") ? 'label-color' : ''}`}>Secondary Color</div>
                                                                <div className='values-container'>
                                                                    <div className='picked-color' id='picked-color-secondary' style={{backgroundColor: `${pickerValues.pickedSecondaryColor}`}}></div>
                                                                    <div className='hex-code'>{pickerValues.pickedSecondaryColor ? pickerValues.pickedSecondaryColor : "--"}</div>
                                                                </div>
                                                            </div>
                                                        </div>) : 
                                                        (<div className='color-picker-container'>
                                                            <div className='color-picker'>
                                                                {pickerValues.isPrimaryClicked && 
                                                                    <Wheel
                                                                    color={pickerValues.pickedPrimaryColor != "#4A4A4A" ? pickerValues.pickedPrimaryColor : "#ffffff"}
                                                                    onChange={(color) => {handlePrimaryColor(color.hex)}}/>}
                                                                {pickerValues.isSecondaryClicked && 
                                                                    <Wheel
                                                                    color={pickerValues.pickedSecondaryColor != "#4A4A4A" ? pickerValues.pickedSecondaryColor : "#ffffff"}
                                                                    onChange={(color) => {handleSecondaryColor(color.hex)}}/>}
                                                            </div>
                                                            <div className='picked-colors-container'>
                                                                <div className='primary-color-container'>
                                                                    <div className={`label ${!(page == "overview-entity" || page == "overview-brand") ? 'label-color' : ''}`}>Primary Color</div>
                                                                    <div className='values-container'>
                                                                        <div className='picked-color' id='picked-color-primary' style={{backgroundColor: `${pickerValues.pickedPrimaryColor && pickerValues.pickedPrimaryColor}`}} 
                                                                        onClick={() => handlePrimaryColor(pickerValues.pickedPrimaryColor)}></div>
                                                                        <input className='hex-code' type="text" value={hexValues.primary}
                                                                        onChange={(e) => {
                                                                            const primary = e.target.value.includes('#') ? e.target.value : "#"+e.target.value;
                                                                            setHexValues({...hexValues, primary: primary})}
                                                                        }
                                                                        onKeyDown={(e) => {
                                                                            if (e.key === "Enter" && e.target.value.length == 7) {
                                                                                handlePrimaryColor(e.target.value)
                                                                            }
                                                                        }}
                                                                        maxLength={45}/>
                                                                    </div>
                                                                </div>
                                                                <div className='secondary-color-container'>
                                                                    <div className={`label ${!(page == "overview-entity" || page == "overview-brand") ? 'label-color' : ''}`}>Secondary Color</div>
                                                                    <div className='values-container'>
                                                                        <div className='picked-color' id='picked-color-secondary' style={{backgroundColor: `${pickerValues.pickedSecondaryColor && pickerValues.pickedSecondaryColor}`}} 
                                                                        onClick={() => handleSecondaryColor(pickerValues.pickedSecondaryColor)}></div>
                                                                        <input className='hex-code' type="text" value={hexValues.secondary}
                                                                        onChange={(e) => {
                                                                            const secondary = e.target.value.includes('#') ? e.target.value : "#"+e.target.value;
                                                                            setHexValues({...hexValues, secondary: secondary})}
                                                                        }
                                                                        onKeyDown={(e) => {
                                                                            if (e.key === "Enter" && e.target.value.length == 7) {
                                                                                handleSecondaryColor(e.target.value)
                                                                            }
                                                                        }}
                                                                        maxLength={45}/>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>)}
                                                </div>
                                                <div className='sub-section2'>
                                                    <div className='sub-header-container2'>
                                                        {(page == 'overview-brand' || page == 'overview-entity' || isChecked) ? 
                                                            (page == 'overview-brand' ? <div className={`label ${!(page == "overview-entity" || page == "overview-brand") ? 'label-color' : ''}`}>Your Portal Fonts</div> : 
                                                            <div className={`label ${!(page == "overview-entity" || page == "overview-brand") ? 'label-color' : ''}`}>Your Property Fonts</div>) : 
                                                            ((page == "create-brand" || page == "edit-brand" || page == "overview-edit-brand") ? 
                                                            <div className={`label ${!(page == "overview-entity" || page == "overview-brand") ? 'label-color' : ''}`}>Select Your Portal Fonts</div> : <div className={`label ${!(page == "overview-entity" || page == "overview-brand") ? 'label-color' : ''}`}>Select Your Property Fonts</div>)}
                                                        {(page != 'overview-brand' && page != 'overview-entity' && !isChecked) && <div className='note'>(2 Fonts Maximum)</div>}
                                                    </div>
                                                    {(page == 'overview-brand' || page == 'overview-entity' || isChecked) ?
                                                        (<div className='overview-font-style-container'>
                                                            <div className='font1-container'>
                                                                <div className={`label ${!(page == "overview-entity" || page == "overview-brand") ? 'label-color' : ''}`}>Font 1</div>
                                                                {values.font1 && values.font1 !="Select Font1" ? (<div style={{fontFamily: values.font1}} className='value'>{values.font1}</div>) :
                                                                    (<div className='value'>--</div>)}
                                                            </div>
                                                            <div className='font2-container'>
                                                                <div className={`label ${!(page == "overview-entity" || page == "overview-brand") ? 'label-color' : ''}`}>Font 2</div>
                                                                {values.font2 && values.font2 !="Select Font2" ? (<div style={{fontFamily: values.font2}} className='value'>{values.font2}</div>) :
                                                                    (<div className='value'>--</div>)}
                                                            </div>
                                                        </div>) : 
                                                        ( <div className='font-style-container'>
                                                            {console.log("Font style", values.font1)}
                                                            <div className='font1-container'>
                                                                <div className={`label ${!(page == "overview-entity" || page == "overview-brand") ? 'label-color' : ''}`}>Font 1</div>
                                                                <div className='dropdown font-dropdown' ref={font1wrapperRef}>
                                                                    <div className='dropdown-name-img font-dropdown-name' onClick={handleFont1Dropdown}>
                                                                        <div style={{fontFamily: values.font1 != "Select Font1" && values.font1}} className='dropdown-name'>{values.font1}</div>
                                                                        <div><img className='arrow' src={font1DropdownClick ? upArrow : downArrow} alt=""></img></div>
                                                                    </div>
                                                                    {font1DropdownClick &&
                                                                        <div className='dropdown-list'>
                                                                            {
                                                                                fontList.length > 0 && fontList.map((item, index) => {
                                                                                    return (
                                                                                        <div style={{fontFamily: item.type}} className='dropdown-content-inner font-dropdown-inner' 
                                                                                        key={index} onClick={(event) => getFont1(event)}>{item.label}</div>
                                                                                    )
                                                                                })
                                                                            }
                                                                        </div>
                                                                    }
                                                                </div>
                                                            </div>
                                                            <div className='font2-container'>
                                                                <div className={`label ${!(page == "overview-entity" || page == "overview-brand") ? 'label-color' : ''}`}>Font 2</div>
                                                                <div className='dropdown font-dropdown' ref={font2wrapperRef}>
                                                                    <div className='dropdown-name-img font-dropdown-name' onClick={handleFont2Dropdown}>
                                                                        <div style={{fontFamily: values.font2 != "Select Font2" && values.font2}} className='dropdown-name'>{values.font2}</div>
                                                                        <div><img className='arrow' src={font2DropdownClick ? upArrow : downArrow} alt=""></img></div>
                                                                    </div>
                                                                    {font2DropdownClick &&
                                                                        <div className='dropdown-list'>
                                                                            {
                                                                                fontList.length > 0 && fontList.map((item, index) => {
                                                                                    return (
                                                                                        <div style={{fontFamily: item.type}} className='dropdown-content-inner font-dropdown-inner' 
                                                                                        key={index} onClick={(event) => getFont2(event)}>{item.label}</div>
                                                                                    )
                                                                                })
                                                                            }
                                                                        </div>
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>)}
                                                </div>
                                            </div>
                                        </div>}
                                        <div className='section3'>
                                            <div className='additional-info-header'>Additional Info</div>
                                            <div className='additional-info-body'>
                                                {(page == "create-entity" || page == "edit-entity" || page == "overview-entity" || page == "overview-edit-entity") && 
                                                <>
                                                    <div className='csm-field additional-field'>
                                                        <div className={`label ${!(page == "overview-entity") ? 'label-color' : ''}`}>CSM</div>
                                                        {page == "overview-entity" ? 
                                                        <div className='overview-field'>{(csmLabel && csmLabel != "Select CSM") ? csmLabel : "--"}</div> :
                                                        <Dropdown label={csmLabel} selectedItem={(name, id) => handleCSMDropdown(id)}
                                                            handleLabel={(value) => setCSMLabel(value)} list={csmList} enable={true}/>}
                                                    </div>
                                                    <div className='from-email-field additional-field'>
                                                        <div className={`label ${!(page == "overview-entity") ? 'label-color' : ''}`}>From Email Address</div>
                                                        {(page == 'overview-entity') ? 
                                                            (<div className='overview-field'>{values.fromEmail ? values.fromEmail : "--"}</div>) : 
                                                            (<input type="email" name="email" maxLength={45} value={values.fromEmail} onChange={(e) => handleFromEmail(e.target.value)}/>)}
                                                    </div>
                                                </>
                                                }
                                                <div className='website-field additional-field'>
                                                    <div className={`label ${!(page == "overview-entity" || page == "overview-brand") ? 'label-color' : ''}`}>Website</div>
                                                    {(page == 'overview-brand' || page == 'overview-entity') ? 
                                                        (values.website != null ? <div className='overview-field overview-website-field'><a href={`${values.website}`} target="_blank">{values.website}</a></div> :
                                                        <div className='overview-field overview-website-field-url'>--</div>) : 
                                                        (<input type="text" value={values.website} onChange={(e) => handleWebsite(e.target.value)}
                                                        maxLength={200}/>)}
                                                </div>
                                            </div>
                                            {showMore && 
                                            <div>
                                                <EntityAdditional page={page} values={values} setValues={setValues} labelStart={labelStart} setLabelStart={setLabelStart}
                                                labelEnd={labelEnd} setLabelEnd={setLabelEnd} labelOpen={labelOpen} setLabelOpen={setLabelOpen} 
                                                audienceLabel={audienceLabel} setAudienceLabel={setAudienceLabel}/>
                                            </div>}
                                            {(page == "create-entity" || page == "edit-entity" || page == "overview-entity" || page == "overview-edit-entity") && 
                                            <p onClick={handleShowMore} className='show-more col-2'>{`${showMore ? "Show Less" : "Show More"}`}</p>}
                                        </div>
                                        {page == "create-brand" &&
                                            <div className='section4'>
                                                <EntityTasks handleTaskDetails={(taskDetails) => handleTaskDetails(taskDetails)} 
                                                parseTaskDetails={[]} addTaskShow={true} taskToggle={taskToggle}/>
                                            </div>}
                                        {(page == "edit-brand" || page == "overview-brand" || page == "overview-edit-brand") &&
                                            <div className='section4'>
                                                {values.tasks != null &&
                                                <EntityTasks handleTaskDetails={(taskDetails) => handleTaskDetails(taskDetails)} 
                                                parseTaskDetails={values.tasks} addTaskShow={(page == "overview-entity" || page == "overview-brand" || page == "edit-entity" || page == "overview-edit-entity") ? false : true} taskToggle={taskToggle}/>}
                                            </div>}
                                        {(page == "edit-entity" || page == "overview-entity" || page == "overview-edit-entity") && 
                                            <div className='section5'>
                                                <div className='notes-header-container'>
                                                    <div className='notes-header'>Notes</div>
                                                    <div><img className='add-notes' src={create} alt='add notes' onClick={handleNotes}></img></div>
                                                </div>
                                                <div className='notes-body'>
                                                    <EntityNotes page={page} entityId={id} showNotes={showNotes} setShowNotes={setShowNotes}/>
                                                </div>
                                            </div>}
                                        {(page == "overview-brand" || page == "edit-brand" || page == "overview-edit-brand") && 
                                            <SubBrands page={page} brandId={id} setOpen={setOpen} setError={setError}/>
                                        }    
                                        {(page == "overview-brand" || page == "edit-brand" || page == "overview-edit-brand" || page == "overview-entity" || page == "edit-entity" || page == "overview-edit-entity") && 
                                        <div id='files' className='files-section'>
                                            <div className='files-container'>
                                                <div className='files-left'>
                                                    <div className='tasks'>Files</div>
                                                    <div className='showing'>Showing { files && files.length } files of { filesList && filesList.length }</div>
                                                    { filesList && filesList.length > 5 &&
                                                        <div className='showall' onClick={ShowFile}>{showAllFile ? "Show Less" : "Show All"}</div>
                                                    }
                                                </div>
                                                {console.log("[PAGE TYPE] Page is ", page)}
                                                {(page == "edit-entity" || page == "overview-edit-entity" || page == "overview-entity") && 
                                                <div className='files-right'>
                                                    <div><img className='upload' src={create} alt='upload' onClick={openUploadPopup}></img></div> 
                                                </div>}
                                            </div>
                                            <div className='files-table'>
                                                <table>
                                                    <thead>
                                                        <tr className='heading-row'>
                                                            <th className='heading-data first-data' style={{minWidth: "200px"}}>
                                                                <div className='heading-arrows'>
                                                                    <div>Name</div>
                                                                    <div className='sort-arrows'>
                                                                        {
                                                                            !(sortValues.sortBy === 'name' && sortValues.sortType === 'asc') &&
                                                                            <img className='uparrow' src={upsort} alt="uparrow" data-sort-by='name' data-sort-type='asc' onClick={(e) => SortFile(e.target.dataset)}></img>
                                                                        }
                                                                        {
                                                                            !(sortValues.sortBy === 'name' && sortValues.sortType === 'desc') &&
                                                                            <img className='downarrow' src={downsort} alt="downarrow" data-sort-by='name' data-sort-type='desc' onClick={(e) => SortFile(e.target.dataset)}></img>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </th>
                                                            <th className='heading-data' style={{minWidth: "200px"}}>
                                                                <div className='heading-arrows'>
                                                                    <div>Url</div>
                                                                    <div className='sort-arrows'>
                                                                        {
                                                                            !(sortValues.sortBy === 'file' && sortValues.sortType === 'asc') &&
                                                                            <img className='uparrow' src={upsort} alt="uparrow" data-sort-by='file' data-sort-type='asc' onClick={(e) => SortFile(e.target.dataset)}></img>
                                                                        }
                                                                        {
                                                                            !(sortValues.sortBy === 'file' && sortValues.sortType === 'desc') &&
                                                                            <img className='downarrow' src={downsort} alt="downarrow" data-sort-by='file' data-sort-type='desc' onClick={(e) => SortFile(e.target.dataset)}></img>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </th>
                                                            <th className='heading-data' style={{minWidth: "200px"}}>
                                                                <div className='heading-arrows'>
                                                                    <div>Date</div>
                                                                    <div className='sort-arrows'>
                                                                        {
                                                                            !(sortValues.sortBy === 'filedate' && sortValues.sortType === 'asc') &&
                                                                            <img className='uparrow' src={upsort} alt="uparrow" data-sort-by='filedate' data-sort-type='asc' onClick={(e) => SortFile(e.target.dataset)}></img>
                                                                        }
                                                                        {
                                                                            !(sortValues.sortBy === 'filedate' && sortValues.sortType === 'desc') &&
                                                                            <img className='downarrow' src={downsort} alt="downarrow" data-sort-by='filedate' data-sort-type='desc' onClick={(e) => SortFile(e.target.dataset)}></img>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </th>
                                                            <th className='heading-data' style={{minWidth: "170px"}}>
                                                                <div className='heading-arrows'>
                                                                    <div>Size</div>
                                                                    <div className='sort-arrows'>
                                                                        {
                                                                            !(sortValues.sortBy === 'size' && sortValues.sortType === 'asc') &&
                                                                            <img className='uparrow' src={upsort} alt="uparrow" data-sort-by='size' data-sort-type='asc' onClick={(e) => SortFile(e.target.dataset)}></img>
                                                                        }
                                                                        {
                                                                            !(sortValues.sortBy === 'size' && sortValues.sortType === 'desc') &&
                                                                            <img className='downarrow' src={downsort} alt="downarrow" data-sort-by='size' data-sort-type='desc' onClick={(e) => SortFile(e.target.dataset)}></img>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </th>
                                                            <th className='heading-data action-heading' style={{width: "120px"}}>Actions</th>
                                                        </tr>
                                                    </thead>
                                                    {
                                                    files.length === 0 ? <p className="no-result">No results found</p> :
                                                        <tbody>
                                                            { files && files.length > 0 && files.map((item, index) => {
                                                                return (
                                                                    <tr className='details-list-row' key={index} onMouseLeave={handleMouseLeave}>  
                                                                        <td className='details-list-data first-data' style={{minWidth: "200px"}}>{item.fileName && item.fileName}</td>
                                                                        <td className='details-list-data' style={{minWidth: "200px"}}>
                                                                            <div className='files-url-copy'>
                                                                                <div>
                                                                                    <a target="_blank" href={`${BASE_URL}/${item.fileUrl && item.fileUrl.replace('\\', '/')}`}>
                                                                                        {item.fileUrl && item.fileUrl.replace('\\', '/')}
                                                                                    </a>
                                                                                </div>
                                                                                <CopyToClipboard
                                                                                    text={`${BASE_URL}/${item.fileUrl && item.fileUrl.replace('\\', '/')}`}
                                                                                    onCopy = {() => setTooltipMessage("Link Copied!")}>
                                                                                    <span>
                                                                                        <Tooltip title={tooltipMessage}>
                                                                                            <div className='icon icon-copy icon-2x'></div>
                                                                                        </Tooltip> 
                                                                                    </span>
                                                                                </CopyToClipboard>                                       
                                                                            </div>
                                                                        </td>
                                                                        <td className='details-list-data' style={{minWidth: "170px"}}>{item.uploadedDate && convertUTCToPST(item.uploadedDate + 'Z', "updates")}</td>
                                                                        <td className='details-list-data' style={{minWidth: "170px"}}>{item.size && item.size}</td>
                                                                        <td className='details-list-data action'><a href={`${BASE_URL}/${item.fileUrl && item.fileUrl}`} download >
                                                                            <img className='download' src={download} alt="download"></img></a>
                                                                            <img className='trash' src={trash} alt="delete" onClick={(e) => DeleteFile(e, item.idFiles)}></img></td>
                                                                    </tr>
                                                                )
                                                            })}
                                                        </tbody>
                                                    }   
                                                </table>
                                            </div>
                                            {/* Showing delete popup */}
                                            <DeleteItem show={showDeleteFile} handleClose={handleCloseFilePopup} deleteApiCall={callDeleteFileApi} enable={true}/>
                                        </div> 
                                        }
                                        {(page == "overview-entity" || page == "edit-entity" || page == "overview-edit-entity") && 
                                            <EntityContacts entityId={id}/>
                                        }
                                        {(page == "overview-entity" || page == "edit-entity" || page == "overview-edit-entity") && 
                                            <FormsTable id={id} page={page}/>
                                        }
                                        {(page != 'overview-brand' && page != 'overview-edit-brand' && page != 'overview-entity' && page != 'overview-edit-entity')  &&
                                            <div className='save-button'>
                                                {(page == "create-brand" || page == "create-entity") ?
                                                    (<button disabled={enable ? false : true} className={enable ? 'add-button enable' : 'add-button disable'} onClick={callAddDetailsApi}>Save</button>)
                                                :
                                                    (<button disabled={enable ? false : true} className={enable ? 'edit-button enable' : 'edit-button disable'} onClick={callUpdateDetailsApi}>Save</button>)
                                                }
                                            </div>}
                                    </>}
                                    {isSettingsClicked && 
                                    <EntitySettings entityId={id}/>}

                                </div>
                            </LoadingOverlay>
                        )}</>)}
                    </div>
                </div>
                <Snackbars error={error} open={open} setOpen={setOpen}/>
                <Upload show={showUploadPopup} handleClose={handleUploadPopupClose} id={id} setUpload={setUpload} uploadstate={uploadstate} setLoadEnd={setLoadEnd} loadend={loadend} setUploaderror={setUploaderror} uploaderror={uploaderror} created={created} pageType="Entities-Files"/>
                <Footer />
            </div>
        </>
    )
}

export default CreateNew;